<!-- Top-bar "Drafts" button — mode-independent (cuts across Design's own
     Business/Strategy/IT Landscape rows rather than living inside them), so it
     sits in the menubar toolbar next to ActivityBar/WhatsNewButton instead of
     the NavRail. Opens the thread drawer on its list of drafts; there is no
     separate full-page drafts list.

     It was a popover until we found the drawer's own list does strictly more —
     it groups by page, marks the one you are viewing, shows resolved drafts
     as history, and has room for per-draft actions. Two surfaces listing the
     same thing was the mess; this is the one. -->
<template>
    <Button
        type="button"
        severity="secondary"
        label="Drafts"
        class="drafts-selector-trigger"
        aria-label="Drafts"
        data-testid="drafts-selector-trigger"
        @click="openDrafts"
    />
</template>

<script lang="ts" setup>
import Button from "primevue/button";

import { useThreadsStore } from "@/stores/threads-store";

const threadsStore = useThreadsStore();

// Opens the drawer on the LIST (no thread selected), which is what
// openThreadsList exists for — the entity discussion badges use it too.
const openDrafts = () => threadsStore.openThreadsList();
</script>
